import React, { useEffect, useState } from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'

/**
 * Multi-select for partner codes. Loads /api/my-business/catalog/partners
 * once on mount (top 100 by volume). Emits an array of partner_code
 * strings.
 */
export default function PartnerSlicer({ value, onChange, sx }) {
	const [options, setOptions] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		fetch('/api/my-business/catalog/partners', { credentials: 'include' })
			.then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
			.then(setOptions)
			.catch(() => setOptions([]))
			.finally(() => setLoading(false))
	}, [])

	const selected = options.filter(o => value.includes(o.partner_code))

	return (
		<Autocomplete
			multiple
			size="small"
			options={options}
			loading={loading}
			value={selected}
			onChange={(_, picked) => onChange(picked.map(p => p.partner_code), { intent: 'pending' })}
			getOptionLabel={(o) => o.partner_code}
			isOptionEqualToValue={(a, b) => a.partner_code === b.partner_code}
			renderTags={(picked, getTagProps) =>
				picked.map((o, i) => (
					<Chip {...getTagProps({ index: i })} key={o.partner_code} size="small"
					      label={o.partner_code}/>
				))
			}
			renderInput={(params) => <TextField {...params} InputLabelProps={{ ...params.InputLabelProps, shrink: true }} label="Partners"/>}
			sx={{ minWidth: 200, ...sx }}
		/>
	)
}
